export function formatDay(dia) {
  if (typeof dia !== "string") return "";

  const lower = dia.trim().toLowerCase();

  // Caso especial
  if (lower === "miércoles") return "Mi";

  // Devuelve la primera letra en mayúscula
  return lower.charAt(0).toUpperCase();
}
